module.exports = __webpack_public_path__ + "img/cn_pocket-2.86a4d3b.jpg";